import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from '@headlessui/react';

import Tabs from 'components/v2/navs/Tabs';
import ShipmentDocuments from 'components/modules/tools/components/ShipmentDocuments';
import InvoiceDocuments from 'components/modules/tools/components/InvoiceDocuments';
import PayoutDocuments from 'components/modules/tools/components/PayoutDocuments';

const getTabs = (t) => [
  { id: 'shipmentDocumentsTab', name: t('SHIPMENT_DOCUMENTS') },
  { id: 'invoicesTab', name: t('INVOICE', { count: 2 }) },
  { id: 'payoutsTab', name: t('PAYOUT', { count: 2 }) },
];

export default function ExportDocuments() {
  const { t } = useTranslation();

  return (
    <Tabs tabs={getTabs(t)}>
      <Tab.Panel>
        <ShipmentDocuments />
      </Tab.Panel>
      <Tab.Panel>
        <InvoiceDocuments />
      </Tab.Panel>
      <Tab.Panel>
        <PayoutDocuments />
      </Tab.Panel>
    </Tabs>
  );
}
